import React from 'react';
import clsx from 'clsx';
import FormHelperText from '@material-ui/core/FormHelperText';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  default: {
    color: theme.palette.darkGrey.light,
  },
  error: {
    color: theme.palette.red.main,
  },
  success: {
    color: theme.palette.green.main,
  },
}));

const FieldHelperText = ({ children, type, className }) => {
  const classes = useStyles();
  return (
    <FormHelperText className={clsx(classes[type], className)}>
      {children}
    </FormHelperText>
  );
};

FieldHelperText.propTypes = {
  type: PropTypes.oneOf(['default', 'success', 'error']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

FieldHelperText.defaultProps = {
  type: 'default',
  className: undefined,
};

export default FieldHelperText;
